import { render, staticRenderFns } from "./BaseReviewMemberListItem.vue?vue&type=template&id=e5d669c4&"
import script from "./BaseReviewMemberListItem.vue?vue&type=script&lang=js&"
export * from "./BaseReviewMemberListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports